import { constants as config } from '@config';

const ShapesFactory = require('../../../factory/shapes');
const ElementSetter = require('../setters/abstract/element');

const GraphicCreator = require('./abstract/graphic');

module.exports = ShapeCreator;

function ShapeCreator () {}
ShapeCreator.prototype = new GraphicCreator();
ShapeCreator.prototype.constructor = ShapeCreator;

ShapeCreator.prototype.initialize = function () {
  GraphicCreator.prototype.initialize.call(this);
  _.extend(this.defaults, { shape_id: null, smart_asset: null });
};

ShapeCreator.prototype.create = function (data) {
  let id;

  if (data.content) {
    id = this._create(data);
  }

  data.shape_id && this.load(data);

  return id;
};

ShapeCreator.prototype.load = function (data) {
  const id = data.shape_id.split('_');
  ShapesFactory.get(id[0], id[1]).then(_.bind(function (shape) {
    data.content = shape.path;
    this._create(data);
  }, this));
};

ShapeCreator.prototype._create = function (data) {
  const element = this.canvas.addSvgElementFromJson({
    element: 'path',
    curStyles: true,
    attr: this.getAddData(data)
  });

  $(element).addClass('element');

  this.setSize(element, data.size
    ? data
    : {
        size: {
          width: this.getDefinedData(data, 'size.width'),
          height: this.getDefinedData(data, 'size.height')
        }
      });

  this.setPosition(element, {
    position: {
      x: this.getDefinedData(data, 'position.x'),
      y: this.getDefinedData(data, 'position.y')
    }
  });

  this.trigger('', element.getAttribute('id'));

  (typeof data.selected === 'undefined' || data.selected) ||
    this.canvas.clearSelection();

  return element.getAttribute('id');
};

ShapeCreator.prototype.setSize = ElementSetter.prototype.updateSize;

ShapeCreator.prototype.setPosition = function (element, data) {
  const p = data.position;
  const bb = element.getBBox();
  const editorFacade = require('../../editor/editor');
  const zoom = editorFacade.handle('zoom', 'get');

  this.canvas.clearSelection();
  this.canvas.selectOnly([element]);
  this.canvas.moveSelectedElements((p.x - bb.x) * zoom, (p.y - bb.y) * zoom);
};

ShapeCreator.prototype.getAddData = function (data) {
  const attr = {
    d: data.content,
    id: this.canvas.getNextId(),
    opacity: this.getDefinedData(data, 'opacity')
  };

  if (data.smart_asset) {
    attr[config.smartAssets.attributes.definedAsset] = data.smart_asset;
  }

  return attr;
};
